import fetcher from '../fetcher'

const CONTACT_FORM = `
mutation contactusFormSubmit($input: ContactusInput!) {
    contactusFormSubmit(input: $input) {
      message
    }
  }
`
const INFORMATION_STORE = `
query GetInformationStore {
  storeAddress {
    city
    city_id
    country_code
    description
    district
    district_id
    email
    fax
    maps
    name
    postcode
    slider_id
    sort_description
    sort_order
    street
    telephone_1
    telephone_2
    ward
    ward_id
  }
} 
`
export const sendContact = async ({ params }: { params: IContactParams }) => {
  const response = await fetcher
    .post('', {
      query: CONTACT_FORM,
      variables: {
        input: params,
      },
    })
    .then((res) => res?.payload)
  const data = response?.data?.message
  if (!data) return { status: 'success', message: 'Something went wrong!', data: data }
  return { status: 'success', message: 'Successfully!', data: data }
}

export const getInfoStore = async () => {
  const response = await fetcher
    .post(
      '',
      {
        query: INFORMATION_STORE,
      },
      {
        next: { revalidate: 300, tags: ['infomation-store'] },
      }
    )
    .then((res) => res?.payload)

  const data = response?.data?.storeAddress
  if (!data) return { status: 'success', message: 'Something went wrong!', data: data }
  return { status: 'success', message: 'Successfully!', data: data }
}
